import { Button } from "@/components/ui/button.jsx";
import { Input } from "@/components/ui/input.jsx";
import { cn } from "@/lib/utils.js";

/**
 * Text filter for measurement names in RCA sections.
 *
 * @param {{
 *   filterText: string,
 *   onFilterTextChange: (value: string) => void,
 *   placeholder?: string,
 *   className?: string,
 * }} props
 */
export default function RcaMeasurementFilter({
  filterText,
  onFilterTextChange,
  placeholder = "Filter measurements",
  className,
}) {
  const hasText = filterText.trim().length > 0;

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <span className='text-xs text-muted-foreground'>Filter:</span>
      <Input
        type='text'
        value={filterText}
        onChange={(e) => onFilterTextChange(e.target.value)}
        placeholder={placeholder}
        className='h-8 min-w-[13rem] max-w-[20rem] text-xs'
        aria-label='Filter measurements by name'
      />
      <Button
        type='button'
        size='sm'
        variant='outline'
        onClick={() => onFilterTextChange("")}
        disabled={!hasText}
        className='h-8 px-2 text-xs'>
        Clear
      </Button>
    </div>
  );
}
